import 'reflect-metadata';
import { jsonArrayMember, jsonObject } from 'typedjson';
import SportsEntityModel from './sports-entity.model';

@jsonObject
export default class SportsEntitiesModel {
	@jsonArrayMember(SportsEntityModel)
	public results: SportsEntityModel[] = [];
}
